//Reset data
export const RESET = "USERACTIVITE_UPDATE_RESET"

export const SET_IS_UPDATED = "USERACTIVITE_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "USERACTIVITE_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "USERACTIVITE_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "USERACTIVITE_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "USERACTIVITE_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "USERACTIVITE_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "USERACTIVITE_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "USERACTIVITE_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "USERACTIVITE_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "USERACTIVITE_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "USERACTIVITE_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "USERACTIVITE_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "USERACTIVITE_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "USERACTIVITE_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "USERACTIVITE_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "USERACTIVITE_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "USERACTIVITE_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "USERACTIVITE_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "USERACTIVITE_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "USERACTIVITE_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "USERACTIVITE_UPDATE_SET_MODAL_TYPE"